import { HubEvents } from "../common/HubEventsEnum";
import { SignalRBaseModel } from "../common/SignalRBaseModel";

export class ProjectAudienceVisualisationsHub extends SignalRBaseModel {
  hubName: string = "project-audiences-visualisations";

  constructor() {
    super("project-audiences-visualisations");
  }

  onData = callback => this.registerIncomingEvent(HubEvents.ON_DATA, callback);

  invokeLoadData = async (organisationId: number, projectId: number) => {
    if (!this.isConnectionStarted) return;
    await this.connection.invoke(HubEvents.INVOKE_LOAD_DATA, {
      organisationId: organisationId,
      projectId: projectId
    });
  };
}
const instance = new ProjectAudienceVisualisationsHub();
export default instance;
